import {
  Select,
  SelectItem,
} from '@energybox/react-ui-library/dist/components';
import { global, isDefined } from '@energybox/react-ui-library/dist/utils';
import React from 'react';

const ctPolarityValues = [false, true];

export enum ctPolarityLabel {
  false = 'Normal',
  true = 'Reverse',
}

type Props = {
  value: boolean;
  onSelect: (value: boolean) => void;
  disabled?: boolean;
  noBottomLine?: boolean;
  error?: boolean;
  customErrorText?: string;
};

const SelectCtPolarity: React.FC<Props> = ({
  value,
  onSelect,
  disabled,
  error,
  customErrorText,
  noBottomLine = false,
}) => {
  return (
    <Select
      title={
        (isDefined(value) && ctPolarityLabel[value.toString()]) ||
        global.NOT_AVAILABLE
      }
      disabled={disabled}
      error={error}
      customErrorText={customErrorText}
      noBottomLine={noBottomLine}
    >
      {ctPolarityValues.map(v => (
        <SelectItem
          key={ctPolarityLabel[String(v)]}
          isSelected={v === value}
          onSelect={() => onSelect(v)}
        >
          {ctPolarityLabel[String(v)]}
        </SelectItem>
      ))}
    </Select>
  );
};

export default SelectCtPolarity;
